

export default {
  "import_results_title": "Transaction Details",
  "import_show_data": "Show Data",
  "import_no_details_available": "No transaction details available",
  "import_data_details": "Data Details",
  "import_data_message": "Message",
  "refresh": "Refresh",
  "close": "Close",
  "import_status": "Status",
  "import_status_processed": "Processed",
  "import_status_failure": "Failure",
  "import_status_pending": "Pending",
  "import_status_unknown": "Unknown",
  
  // Messages for the details modal
  "import_company_id": "Company ID",
  "import_unit_tags": "Tags",
  
  "import_tag__id": "Tag ID",
  "import_tag__label": "Tag Name", 
  "import_tag__color": "Color",
  "import_tag__parentlabel": "Parent Tag",
  
  "import_unit__esn": "ESN",
  "import_unit__id": "Unit ID",
  "import_unit__label": "Unit Name",
  "import_unit__driver": "Driver",
  "import_unit__engine_hours": "Engine Hours",
  "import_unit__default_driver": "Default Driver",
  "import_unit__vin": "VIN",
  "import_unit__make": "Make",
  "import_unit__model": "Model",
  "import_unit__year": "Year",
  "import_unit__odometer": "Odometer",
  "import_unit__inspection_device_type": "Inspection Device Type",
  "import_unit__power_unit_number": "Power Unit Number",
  "import_unit__inspection_tag_id": "Inspection Tag ID",
  "import_unit__maintenance_company": "Maintenance Company",
  "import_unit__registration_country": "Registration Country",
  "import_unit__registration_state": "Registration State",
  "import_unit__registration_expiration": "Registration Expiration",
  "import_unit__engine_serial_number": "Engine Serial Number",
  "import_unit__license_plate": "License Plate",
  "import_unit__asset_type": "Asset Type",
  "import_unit__asset_subtype": "Asset Subtype",


  // Driver fields
  "import_driver__id": "ID",
  "import_driver__code": "Driver Code",
  "import_driver__name": "Driver Name",
  "import_driver__employee_number": "Employee Number",
  "import_driver__keyfob": "KeyFob",
  "import_driver__supervisor": "Supervisor",
  "import_driver__vehicle": "Vehicle",
  "import_driver__status": "Status",
  "import_driver__timezone": "Timezone",
  "import_driver__tags": "Tags",
  "import_driver__email": "Email",
  "import_driver__phone": "Phone",
  "import_driver__ignition_driver_app": "Ignition Driver app",
  "import_driver__pin_number": "Pin Number",
  "import_driver__license_number": "License Number",
  "import_driver__license_expiration": "License Expiration Date",
  "import_driver__registration_country": "Registration Country",
  "import_driver__registration_state": "Registration State",
  "import_driver__hours_of_service_ruleset": "Hours of Service Ruleset",
  "import_driver__hours_of_service_exempt": "Hours of Service Exempt",
  "import_driver__exempt_comment": "Exempt Comment",
  "import_driver__personal_conveyance": "Personal Conveyance",
  "import_driver__allowed_pc_distance": "Allowed PC Distance",
  "import_driver__yard_moves": "Yard Moves",

  
  "import_asset__id": "Asset ID",
  "import_asset__name": "Asset Name",
  "import_asset__type": "Asset Type",
  
  "import_user__id": "User ID", 
  "import_user__first_name": "First Name",
  "import_user__last_name": "Last Name",
  "import_user__username": "Username",
  "import_user__email": "Email",
  "import_user__cell": "Cell",
  "import_user__role": "Role",
  "import_user__tags": "Tags",
  "import_user__expiration_date": "Expiration Date",
  "import_asset__vin": "VIN",
  "import_asset__make": "Make",
  "import_asset__model": "Model",
  "import_asset__year": "Year",
  "import_asset__status": "Status",
  "import_asset__inspection_device_type": "Inspection Device Type",
  "import_asset__power_unit_number": "Power Unit Number",
  "import_asset__inspection_tag_id": "Inspection Tag ID",
  "import_asset__asset_type": "Asset Type",
  "import_asset__asset_subtype": "Asset Subtype",
  "import_asset__external_id": "External ID",
  "import_asset__maintenance_company": "Maintenance Company",
  "import_asset__registration_country": "Registration Country",
  "import_asset__registration_state": "Registration State",
  "import_asset__registration_expiration": "Registration Expiration",
  "import_asset__engine_serial_number": "Engine Serial Number",
  "import_asset__chassis_serial_number": "Chassis Serial Number",
  "import_asset__license_plate": "License Plate",

  "import_user__id": "User ID",
  "import_user__name": "User Name",
  "import_user__email": "Email",
  // Unit import error messages
  "import_errormsg_U001": "Empty ID - row skipped",
  "import_errormsg_U002": "Invalid ID format (must be a positive integer): {{unitId}}",
  "import_errormsg_U003": "Label cannot be empty - label is required for unit updates",
  "import_errormsg_U004": "Unit with ID not found in account: {{unitId}}",
  "import_errormsg_U005": "Access denied: No permission to modify this unit: {{unitLabel}}",
  "import_errormsg_U006": "Tag does not exist: {{tagName}}",
  "import_errormsg_U007": "Access denied: No permission to assign tags: {{tagName}}",
  "import_errormsg_U008": "No changes detected for unit: {{unitLabel}}",
  "import_errormsg_U009": "Invalid IMEI format (must be 15 digits)",
  "import_errormsg_U010": "Unit label too long (maximum 47 characters): {{unitLabel}}",
  "import_errormsg_U011": "VIN too long (maximum 17 characters): {{unitVin}}",
  "import_errormsg_U012": "Make too long (maximum 30 characters): {{unitMake}}",
  "import_errormsg_U013": "Invalid engineHours value (must be numeric): {{engineHours}}",
  "import_errormsg_U014": "Invalid odometer value (must be numeric): {{odometer}}",
  "import_errormsg_U015": "Invalid vehicle year (must be between 1900 and current year + 1): {{vehicleYear}}",
  "import_errormsg_U016": "Driver not found in account: {{unitDriver}}",
  "import_errormsg_U017": "Driver lookup failed for: {{unitDriver}}",
  "import_errormsg_U018": "Error updating unit: {{unitLabel}}",
  "import_errormsg_U019": "Processing error for unit: {{unitLabel}}",
  "import_errormsg_U020": "Invalid inspection device type for asset: {{unitInspectionDeviceType}}",
  "import_errormsg_U021": "Power Unit Number too long (maximum 10 characters)",
  "import_errormsg_U022": "Inspection tag ID too long (maximum 9 characters)",
  "import_errormsg_U023": "Invalid engineHours value (cannot be negative): {{engineHours}}",
  "import_errormsg_U024": "Invalid odometer value (cannot be negative): {{odometer}}",
  "import_errormsg_U025": "Invalid engineHours value (exceeds maximum allowed): {{engineHours}}",
  "import_errormsg_U026": "Invalid odometer value (exceeds maximum allowed): {{odometer}}",
  "import_errormsg_U027": "Default Driver not found in account: {{defaultDriver}}",
  "import_errormsg_U028": "Default Driver lookup failed for: {{defaultDriver}}",
  "import_errormsg_U029": "Invalid maintenance company: {{unitMaintenanceCompany}}",
  "import_errormsg_U030": "Invalid registration country format: {{unitRegisCountry}}",
  "import_errormsg_U031": "Registration country not found in database: {{unitRegisCountry}}",
  "import_errormsg_U032": "Invalid registration state format: {{unitRegisState}}",
  "import_errormsg_U033": "Registration state not found in database: {{unitRegisState}}",
  "import_errormsg_U034": "Invalid registration expiration date format: {{unitRegisExpDate}}",
  "import_errormsg_U035": "Invalid registration expiration year: {{unitRegisExpDate}}",
  "import_errormsg_U036": "Asset type cannot be empty when updating a unit",
  "import_errormsg_U037": "Asset subtype cannot be empty when updating a unit",
  "import_errormsg_U038": "Asset type not found: {{unitAssetType}}",
  "import_errormsg_U039": "Asset subtype not found: {{unitAssetSubtype}}",
  "import_errormsg_U040": "Error resolving asset type/subtype",
  "import_errormsg_U041": "Engine serial number must be alphanumeric: {{unitEngineSerialNumber}}",
  "import_errormsg_U042": "Engine serial number too long (maximum 30 characters).",
  "import_errormsg_U043": "License plate must be alphanumeric: {{unitLicensePlate}}",
  "import_errormsg_U044": "License plate too long (maximum 20 characters): {{unitLicensePlate}}",
  "import_errormsg_U045": "Inspection tag ID must be numeric and positive: {{unitInspectionTagId}}",
  "import_errormsg_U046": "Vehicle model too long (maximum 50 characters): {{unitModel}}",
  "import_errormsg_U047": "Inspection tag ID must be a positive number greater than zero: {{unitInspectionTagId}}",
  "import_errormsg_U048": "Chassis serial number must be alphanumeric: {{unitChassisSerialNumber}}",
  "import_errormsg_U049": "Chassis serial number too long (maximum 30 characters): {{unitChassisSerialNumber}}",
  "import_errormsg_U050": "Invalid state for Colombia: expected \"CO-CO\": {{unitRegisState}}",
  "import_errormsg_U051": "Invalid state for Peru: expected \"PE-PE\": {{unitRegisState}}",
  "import_errormsg_U052": "Invalid state for country \"None\": expected \"None\": {{unitRegisState}}",
  "import_errormsg_U053": "State is required for United States/Canada registrations: {{unitRegisCountry}}",
  "import_errormsg_U054": "State does not belong to the specified country: {{unitRegisState}}",
  "import_errormsg_U055": "Registration country is required when registration state is provided.",
  // Tag import error messages
  "import_errormsg_T001": "Missing required field: Tag Label",
  "import_errormsg_T002": "Tag label too long (maximum 100 characters): {{tagLabel}}",
  "import_errormsg_T003": "Tag label cannot be empty",
  "import_errormsg_T004": "Invalid ID format: ID must contain only numbers: {{tagId}}",
  "import_errormsg_T005": "Tag with ID not found in company: {{tagId}}",
  "import_errormsg_T006": "Access denied: No permission to modify tag: {{tagLabel}}",
  "import_errormsg_T007": "Parent tag not found: {{parentLabel}}",
  "import_errormsg_T008": "Invalid operation: Tag cannot be its own parent: {{tagLabel}}",
  "import_errormsg_T009": "Access denied: No permission to parent tag: {{parentLabel}}",
  "import_errormsg_T010": "Tag label already exists (duplicate): {{tagLabel}}",
  "import_errormsg_T011": "No changes detected for tag: {{tagLabel}}",
  "import_errormsg_T012": "Processing error for tag: {{tagLabel}}",
  "import_errormsg_T013": "Error creating tag: {{tagLabel}}",
  "import_errormsg_T014": "Error updating tag: {{tagLabel}}",

  // Asset import error messages
  "import_errormsg_A002": "Invalid ID format (must be a positive integer): {{assetId}}",
  "import_errormsg_A003": "Asset label cannot be empty",
  "import_errormsg_A004": "Asset with ID not found in account: {{assetId}}",
  "import_errormsg_A005": "Access denied: No permission to modify asset: {{assetLabel}}",
  "import_errormsg_A006": "Tag not found in account: {{tagNameAsset}}",
  "import_errormsg_A007": "Access denied: No permission to assign tags: {{tagNameAsset}}",
  "import_errormsg_A008": "No changes detected for asset: {{assetLabel}}",
  "import_errormsg_A010": "Error creating asset: Label already in use: {{assetLabel}}",
  "import_errormsg_A011": "Error updating asset: Label already in use: {{assetLabel}}",
  "import_errormsg_A013": "VIN too long (maximum 17 characters): {{assetVin}}",
  "import_errormsg_A014": "Make too long (maximum 30 characters): {{assetMake}}",
  "import_errormsg_A015": "Model too long (maximum 50 characters): {{assetModel}}",
  "import_errormsg_A016": "Invalid year (must be between 1980 and current year + 1): {{assetYear}}",
  "import_errormsg_A017": "License plate too long (maximum 10 characters): {{licensePlate}}",
  "import_errormsg_A018": "Processing error for asset: {{assetLabel}}",
  "import_errormsg_A019": "Error creating asset: {{assetLabel}}",
  "import_errormsg_A020": "Error updating asset: {{assetLabel}}",
  "import_errormsg_A021": "Asset type not found: {{assetTypeName}}",
  "import_errormsg_A022": "Asset subtype not found: {{assetSubtypeName}}",
  "import_errormsg_A023": "Error resolving asset type/subtype: {{assetLabel}}",
  "import_errormsg_A024": "Error creating asset: External ID already in use: {{assetExternalId}}",
  "import_errormsg_A025": "Error updating asset: External ID already in use: {{assetExternalId}}",
  "import_errormsg_A026": "Label exceeds maximum length of 50 characters",
  "import_errormsg_A027": "External ID exceeds maximum length of 50 characters",
  "import_errormsg_A028": "VIN must be alphanumeric: {{assetVin}}",
  "import_errormsg_A029": "External ID must be alphanumeric: {{assetExternalId}}",
  "import_errormsg_A030": "Asset type cannot be empty when updating/creating an asset",
  "import_errormsg_A031": "Asset subtype cannot be empty when updating/creating an asset",
  "import_errormsg_A032": "Error creating asset: VIN already in use: {{assetVin}}",
  "import_errormsg_A033": "Error updating asset: VIN already in use: {{assetVin}}",
  "import_errormsg_A034": "Invalid inspection tag ID format: Inspection tag ID must be a number: {{inspectionTagId}}",
  "import_errormsg_A035": "Inspection too long (maximum 9 characters): {{inspectionTagId}}",
  "import_errormsg_A036": "Invalid inspection tag ID format: Inspection tag ID must be a positive number greater than zero: {{inspectionTagId}}",
  "import_errormsg_A037": "Maintenance company not found: {{assetMaintenanceCompany}}",
  "import_errormsg_A038": "Invalid registration country format: {{assetRegisCountry}}",
  "import_errormsg_A039": "Registration country not found in database: {{assetRegisCountry}}",
  "import_errormsg_A040": "Invalid registration state format: {{assetRegisState}}",
  "import_errormsg_A041": "Registration state not found in database: {{assetRegisState}}",
  "import_errormsg_A042": "Invalid registration expiration date format: {{assetRegisExpiration}}",
  "import_errormsg_A043": "Invalid registration expiration year (must be between 1980 and current year + 1): {{assetRegisExpiration}}",
  "import_errormsg_A044": "Engine serial number must be alphanumeric: {{assetEngSerialNumber}}",
  "import_errormsg_A045": "Engine serial number too long (maximum 30 characters): {{assetEngSerialNumber}}",
  "import_errormsg_A046": "License plate must be alphanumeric: {{assetLicensePlate}}",
  "import_errormsg_A047": "License plate too long (maximum 20 characters): {{assetLicensePlate}}",
  "import_errormsg_A048": "Power unit number too long (maximum 10 characters): {{assetPowerUnitNumber}}",
  "import_errormsg_A049": "Invalid inspection device type: {{assetInspectionDeviceType}}",
  "import_errormsg_A050": "Chassis serial number must be alphanumeric: {{assetChasSerialNumber}}",
  "import_errormsg_A051": "Chassis serial number too long (maximum 30 characters): {{assetChasSerialNumber}}",
  "import_errormsg_A052": "Invalid state for Colombia: expected \"CO-CO\": {{assetRegisState}}",
  "import_errormsg_A053": "Invalid state for Peru: expected \"PE-PE\": {{assetRegisState}}",
  "import_errormsg_A054": "Invalid state for country \"None\": expected \"None\": {{assetRegisState}}",
  "import_errormsg_A055": "State is required for United States/Canada registrations: {{assetRegisCountry}}",
  "import_errormsg_A056": "State does not belong to the specified country: {{assetRegisState}}",
  "import_errormsg_A057": "Registration country is required when registration state is provided.",
  "import_errormsg_A058": "Asset status is invalid: {{assetStatus}}. Allowed values are Active or Inactive.",
  "import_errormsg_A059": "Error updating asset: License plate already in use: {{assetLicensePlate}}",
  "import_errormsg_A060": "Error updating asset: Inspection tag ID already in use: {{inspectionTagId}}",
  "import_errormsg_A061": "Error creating asset: License plate already in use: {{assetLicensePlate}}",
  "import_errormsg_A062": "Error creating asset: Inspection tag ID already in use: {{inspectionTagId}}",


  // User import error messages
  "import_errormsg_US001": "Empty CSV file: The file contains no data rows. Please add at least one row with user information.",
  "import_errormsg_US002": "CSV format error: The ID column is required for user updates.",
  "import_errormsg_US003": "No valid data rows found: ID, Name, Last Name, Email, Username, Role, Tags columns cannot be empty in all rows.",
  "import_errormsg_US004": "ID is required - only existing users can be updated",
  "import_errormsg_US005": "Invalid ID format: ID must be a positive integer without decimals",
  "import_errormsg_US006": "User with ID {{userId}} not found in company",
  "import_errormsg_US007": "Role not found: {{userRole}}",
  "import_errormsg_US008": "Tag {{userTag}} not found",
  "import_errormsg_US009": "Access denied: No permission to assign tag {{userTag}}",
  "import_errormsg_US010": "First Name cannot be empty - name is required for user updates",
  "import_errormsg_US011": "Last Name cannot be empty - last name is required for user updates",
  "import_errormsg_US012": "Email cannot be empty - email is required for user updates",
  "import_errormsg_US013": "Invalid Email format - email must be valid",
  "import_errormsg_US014": "Role cannot be empty - role is required for user updates",
  "import_errormsg_US015": "Tag cannot be empty - tag is required for user updates",
  "import_errormsg_US016": "Access denied: No permission to modify this user",
  "import_errormsg_US017": "Username cannot be empty - username is required for user updates",
  "import_errormsg_US018": "Warning: Username is immutable and cannot be changed via CSV import",
  "import_errormsg_US019": "Warning: Email is immutable and cannot be changed via CSV import",
  "import_errormsg_US020": "Invalid Phone format: phone must contain only digits",
  "import_errormsg_US021": "Phone too short: phone must be at least 10 digits",
  "import_errormsg_US022": "Phone too long: phone must be at most 15 digits",
  "import_errormsg_US023": "First Name too long: first name must be maximum 50 characters",
  "import_errormsg_US024": "Last Name too long: last name must be maximum 50 characters",
  "import_errormsg_US025": "Invalid expiration date format: {{userExpiryDate}}",
  "import_errormsg_US026": "Invalid expiration year (must be between 1900 and current year + 1): {{userExpiryDate}}",

  // Driver import error codes
  "import_errormsg_D001": "Missing required field: Code",
  "import_errormsg_D002": "Missing required field: Driver Name",
  "import_errormsg_D003": "Missing required field: Employee Number",
  "import_errormsg_D004": "Missing required field: Pin Number",
  "import_errormsg_D005": "Missing required field: License Number",
  "import_errormsg_D006": "Missing required field: Registration Country",
  "import_errormsg_D007": "Missing required field: Registration State",
  "import_errormsg_D008": "Missing required field: Timezone",
  "import_errormsg_D009": "Missing required field: Tags",
  "import_errormsg_D010": "Missing required field: KeyFob",
  "import_errormsg_D011": "Missing required field: Hours of Service Ruleset (when Zonar ELD enabled)",
  "import_errormsg_D012": "Processing error (general catch-all)",
  "import_errormsg_D020": "Code exceeds maximum length of 40 characters",
  "import_errormsg_D021": "Driver Name exceeds maximum length of 100 characters",
  "import_errormsg_D022": "Employee Number exceeds maximum length of 20 characters",
  "import_errormsg_D023": "Pin Number exceeds maximum length of 4 characters",
  "import_errormsg_D024": "License Number exceeds maximum length of 15 characters",
  "import_errormsg_D025": "KeyFob exceeds maximum length of 20 characters",
  "import_errormsg_D026": "Email exceeds maximum length of 50 characters",
  "import_errormsg_D027": "Phone Number exceeds maximum length of 15 characters",
  "import_errormsg_D030": "Invalid License Expiration Date format",
  "import_errormsg_D031": "Invalid email format",
  "import_errormsg_D032": "Phone Number must contain only digits",
  "import_errormsg_D033": "Allowed PC Distance must be a valid number",
  "import_errormsg_D034": "Employee Number must be a whole number (integers only, no decimals)",
  "import_errormsg_D035": "Allowed PC Distance is required when Personal Conveyance is Yes",
  "import_errormsg_D036": "Allowed PC Distance must be at least 5 miles (8 km)",
  "import_errormsg_D037": "Allowed PC Distance must not exceed 1608 km (1000 miles)",
  "import_errormsg_D038": "Pin Number must contain only numbers",
  "import_errormsg_D039": "KeyFob must contain only numbers",
  "import_errormsg_D041": "Employee Number already exists (duplicate): {{employeeNumber}}",
  "import_errormsg_D042": "Username already exists: {{driverUsername}}",
  "import_errormsg_D043": "Driver Name already exists (duplicate): {{driverName}}",
  "import_errormsg_D044": "No permission for tags",
  "import_errormsg_D045": "Email address already exists: {{driverEmail}}",
  "import_errormsg_D046": "Phone Number already exists (duplicate): {{driverPhone}}",
  "import_errormsg_D047": "Driver Code already exists (duplicate): {{driverCode}}",
  "import_errormsg_D048": "KeyFob already exists (duplicate): {{keyFob}}",
  "import_errormsg_D049": "License Number already exists (duplicate): {{licenseNumber}}",
  "import_errormsg_D050": "Error creating driver",
  "import_errormsg_D051": "Error updating driver",
  "import_errormsg_D052": "Exempt Comment must be empty when Hours of Service Exempt is No",
  "import_errormsg_D053": "No changes detected",
  "import_errormsg_D054": "Timezone not found: {{driverTimezone}}",
  "import_errormsg_D055": "Vehicle not found: {{driverVehicle}}",
  "import_errormsg_D056": "Supervisor not found: {{driverSupervisor}}",
  "import_errormsg_D057": "HOS Ruleset not found: {{driverHosRuleset}}",
  "import_errormsg_D058": "Invalid Country code: {{driverRegisCountry}}",
  "import_errormsg_D059": "Country code not found in database: {{driverRegisCountry}}",
  "import_errormsg_D060": "Invalid State code: {{driverRegisState}}",
  "import_errormsg_D061": "State code not found in database: {{driverRegisState}}",
  "import_errormsg_D062": "Invalid ID format: ID must be a positive number: {{driverId}}",
  "import_errormsg_D063": "Driver with ID not found in company: {{driverId}}",
  "import_errormsg_D064": "Invalid email format - consecutive dots not allowed",
  "import_errormsg_D065": "Invalid email format - invalid domain structure",
  "import_errormsg_D066": "Exempt Comment is required when Hours of Service Exempt is Yes",
  "import_errormsg_D067": "Access denied: No permission to modify driver: {{driverName}}",

}